import { render, staticRenderFns } from "./AllowedModal.vue?vue&type=template&id=6d89012e&"
import script from "./AllowedModal.vue?vue&type=script&lang=js&"
export * from "./AllowedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports